var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaginationBackPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pagination - Back Previous@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Styleguide",
    transform: "translate(-338.000000, -9486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(0.000000, 6947.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pagination---Back-Previous",
    transform: "translate(338.000000, 2539.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1277704,0.5 C3.5776195,0.5 2.94057806,0.623018378 2.28210802,0.975172007 C1.71739041,1.27718629 1.27718629,1.71739041 0.975172007,2.28210802 C0.623018378,2.94057806 0.5,3.5776195 0.5,5.1277704 L0.5,28.8722296 C0.5,30.4223805 0.623018378,31.0594219 0.975172007,31.717892 C1.27718629,32.2826096 1.71739041,32.7228137 2.28210802,33.024828 C2.94057806,33.3769816 3.5776195,33.5 5.1277704,33.5 L28.8722296,33.5 C30.4223805,33.5 31.0594219,33.3769816 31.717892,33.024828 C32.2826096,32.7228137 32.7228137,32.2826096 33.024828,31.717892 C33.3769816,31.0594219 33.5,30.4223805 33.5,28.8722296 L33.5,5.1277704 C33.5,3.5776195 33.3769816,2.94057806 33.024828,2.28210802 C32.7228137,1.71739041 32.2826096,1.27718629 31.717892,0.975172007 C31.0594219,0.623018378 30.4223805,0.5 28.8722296,0.5 L5.1277704,0.5 Z",
    id: "Rectangle-13-Copy-12",
    stroke: "#D4D3E2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#050D33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(16.785714, 17.214286) scale(-1, 1) translate(-16.785714, -17.214286) ",
    points: "14.7857143 13.2142857 18.7857143 17.2142857 14.7857143 21.2142857"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationBackPrevious);
export default __webpack_public_path__ + "static/media/pagination-back-previous.7f5412ce779cc9d27edf3a96305b54d8.svg";
export { ForwardRef as ReactComponent };